var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.069,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.58
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.221,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.71
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.651,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.58
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C727"
    },
    d: "M293.79,232.568c0-5.869-5.75-10.013-11.318-8.157l-10.462,3.487l-2.54-15.342  c-1.519-9.152-9.361-15.795-18.643-15.795h-9.786l-10.235,12.597h13.552l-3.793,18.733l-11.038-3.68  c-5.568-1.856-11.318,2.288-11.318,8.157v63.65l15.234-15.234l-7.179,21.533h-8.056v12.597h75.58v-12.597h-8.056l-7.179-21.533  l15.234,15.234v-63.65L293.79,232.568L293.79,232.568z M249.702,302.516h-10.155l6.983-18.648l3.172,4.051V302.516z   M262.298,302.516v-14.597l3.172-4.051l6.983,18.648L262.298,302.516L262.298,302.516z M256,279.685c0,0-19.485-13.187-18.698-37.79  c0,0,12.006-1.968,18.698-12.597c6.692,10.628,18.698,12.597,18.698,12.597C275.485,266.498,256,279.685,256,279.685z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.a82453ab7b7ca6176df8e8accbccafb2.svg";
export { ForwardRef as ReactComponent };